export const moduleEnum = {
  "APCC": "Add Payment - Cash, Check, CC",
  "MKA": "Manage Kids Allergies",
  "APO": "Add Payment - Online",
  "SR": "Standard reports",
  "LMCU": "Lunch Menu Creation - Upload",
  "BMCU": "Breakfast Menu Creation - Upload",
  "SMCU": "Snackes Menu Creation - Upload",
  "VBM": "View Breakfast Menu",
  "VSM": "View Snack Menu",
  "VLM": "View Lunch Menu",
  "VDM": "View Dinner Menu",
  "SSISI": "School SIS Integration",
  "ECM": "Extended Caterer Module",
  "LOM": "Lunch Order Management",
  "AEM": "Activities/Events Management",
  "BMCI": "Breakfast Menu Creation - Interactive",
  "LETM": "Lunch Eligibility type management",
  "OLEA": "Online Lunch Eligibility Application",
  "BMM": "Breakfast Menu Management",
  "BOM": "Breakfast Order Management",
  "ER": "Extended reports",
  "MAFP": "Mobile App for Parents",
  "SM": "Student Management",
  "FNSAR": "FNS Audit Reports",
  "BACP": "Before & After Care Payment",
  "BACM": "Before and after care management",
  "PR": "Parent Registration",
  "OWALL": "Online Wallet",
  "ECR": "Extended Caterer Reports",
  "SIU": "Student Import - Upload",
  "LMM": "Lunch Menu Management",
  "MCS": "Milk card support",
  "IPFO": "Instant Payment for Orders",
  "POSD": "POS app to support disbursement",
  "PREOL": "Pre Order Lunch",
  "MPAE": "Make payments for activities/Events",
  "CM": "Caterer Management",
  "MOT": "Menu Order Type",
  "LMCI": "Lunch Menu Creation - Interactive",
  "SMCI": "Snack Menu Creation - Interactive",
  "SMCU": "Snack Menu Creation - Upload",
  "SMM": "Snack Menu Management",
  "SOM": "Snack Order Management",
  "DMCI": "Dinner Menu Creation - Interactive",
  "DMCU": "Dinner Menu Creation - Upload",
  "DMM": "Dinner Menu Management",
  "DOM": "Dinner Order Management",
  "PPFO": "Pre Pay For Order",
  "CEPS": "CEP School",
  "NSO": "Non School Organization",
  "ESEA": "ESEA Application"
};





// WEBPACK FOOTER //
// ./src/server/modules.js